import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import OpenLink from "./OpenLink";
import {
  fetchOpenLinkData,  // Замена OpenLinkCreator
  setLink,            // Замена setLinkCreator
  setFullLink,
  fetchOpenDoor,      // Замена OpenDoorCreator
  updateIsLoading,    // Замена updateLoading
  setFlagOpen,
  setLoadingPage,     // Замена updateLoadingPage
} from "store/openlink-slice";
import { useEffect } from "react";
//
const OpenLinkContainer = ({
  openlink,
  fetchOpenLinkData,  // Обновлённое имя
  setLink,            // Обновлённое имя
  setFullLink,      // Обновлённое имя
  fetchOpenDoor,      // Обновлённое имя
  updateIsLoading,    // Обновлённое имя
  setFlagOpen,
  setLoadingPage,     // Обновлённое имя
}) => {
  useEffect(() => {
    const linkhash = window.location.href;
    setLink(linkhash); // Используем setLink вместо setLinkCreator
  }, [setLink]);

  useEffect(() => {
    if (openlink.link) {
      chekLinkActive();
    }
  }, [openlink.link, fetchOpenLinkData]);

  const chekLinkActive = () => {
    setLoadingPage(); // Используем setLoadingPage вместо updateLoadingPage
    fetchOpenLinkData(openlink.link); // Используем fetchOpenLinkData вместо OpenLinkCreator
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (openlink.link) {
        setLoadingPage();
        fetchOpenLinkData(openlink.link);
      }
    }, 10800000); // 3 часа
    return () => clearInterval(intervalId);
  }, [openlink.link, fetchOpenLinkData, setLoadingPage]);

  useEffect(() => {
    if (openlink.fullLink && !openlink.response.error) {
      fetchOpenDoor(openlink.fullLink); // Используем fetchOpenDoor вместо OpenDoorCreator
    }
  }, [openlink.fullLink, openlink.response.error]);

  const handleSetFullLink = (value) => {
    setFullLink(value); // Используем setFullLink напрямую
  };

  return (
    <OpenLink
      state={{ openlink }}
      setFullLink={handleSetFullLink}
      FlagOpen={setFlagOpen}
      chekLinkActive={chekLinkActive}
    />
  );
};
const mapStateToProps = (state) => ({ openlink: state.openlink });

export default compose(
  connect(mapStateToProps, { 
    fetchOpenLinkData, 
    setLink, 
    setFullLink, 
    fetchOpenDoor, 
    updateIsLoading, 
    setFlagOpen, 
    setLoadingPage 
  })
)(OpenLinkContainer);
